import template from './facility-edit-form.html';
import controller from './facility-edit-form-controller';

const FacilityEditFormComponent = {
    bindings: {
        facility: '<',
        facilityFields: '<',
        facilitySettings: '<',
        practitionerList: '<',
        relatedModels: '<',
        campusList: '<',
        updateTree: '&'
    },
    controller,
    template
};

export default FacilityEditFormComponent;



// WEBPACK FOOTER //
// ./app/components/client-edit/facility-edit-form/facility-edit-form-component.js